import { Component, ViewChild, OnInit } from '@angular/core';
import { DialogBoxPrintComponentAnalisisDeBrechas } from './dialog/dialog-print-box.component';
import { MatTable } from '@angular/material/table';
import { MatDrawer } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { AnalisisDeBrechasService } from '../../services/analisis-de-brechas.service';
import { AnalisisDeBrechas } from 'app/main/models/analisis-de-brechas.model';
import {SelectionModel} from '@angular/cdk/collections';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import { DialogBoxComponent } from './dialog/dialog-box.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import {DialogAnalisisComparatorBoxAnalyticsComponentAnalisisDeBrechas} from './dialog/dialog-analisis-analytics-comparator-box.component';
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';

const ELEMENT_DATA: AnalisisDeBrechas[] = [];

@Component({
    selector   : 'analisis-de-brechas',
    templateUrl: './analisis-de-brechas.component.html',
    styleUrls  : ['./analisis-de-brechas.component.scss']
})
export class AnalisisDeBrechasComponent
{
    displayedColumns: string[] = ['select', 'nombre', 'estructuraJerarquica','marcoDeReferencia','tablasDeEvaluacion',
                              'responsable','creador','estado','fechaFin','action'];
    dataSource = ELEMENT_DATA;
    selection = new SelectionModel<AnalisisDeBrechas>(true, []);
    filterForm: FormGroup;
    role = null;
    estados = ["PRE_INICIADO","COMPLETADO","CERRADO"];

    basicSlice = 10;
    elementCount = 0;

    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    //this.paginator._intl.itemsPerPageLabel="Ítems por página";

    constructor(public dialog: MatDialog,
                private _formBuilder: FormBuilder,
                public router: Router,
                private storage: TokenStorageService,
                private _snackBar: MatSnackBar,
                private _fuseProgressBarService: FuseProgressBarService,
                private analisisDeBrechaservice: AnalisisDeBrechasService) {}

    ngOnInit() {
      this.filterForm = this._formBuilder.group({});
      this.analisisDeBrechaservice.count(this.filterForm).subscribe(req => {
        this.elementCount = req.body;
      });
      this.getElements(0);
    }

    loadData():void{
      this.getElements(0);
    }

    getElements(pageIndex){

      this._fuseProgressBarService.show();

      var user = this.storage.getUser();
      this.role = this.storage.getRole();

      this.filterForm.value["pagina"] = pageIndex;
      this.filterForm.value["cantidad"] = this.basicSlice;

      this.analisisDeBrechaservice.getAll(this.filterForm).pipe().subscribe(req => {

        this.dataSource = [];

        req.body.map( evaluacion => {

          var evaluacionData = {
            id: evaluacion.id,
            nombre: evaluacion.nombre,
            marcoDeReferencia: evaluacion.marcoDeReferencia,
            tablaDeAnalisisDeBrechas: evaluacion.tablaDeAnalisisDeBrechas,
            estructuraJerarquica: evaluacion.estructuraJerarquica,
            fechaCreado: evaluacion.fechaCreado,
            nodoEstructuraJerarquica: evaluacion.nodoEstructuraJerarquica,
            responsable: evaluacion.responsable,
            fechaFin: evaluacion.fechaFin,
            estado: evaluacion.estado,
            creador: evaluacion.creador,
            tieneEliminar: (user==evaluacion.creador.correoElectronico &&
              (this.role.includes(4) || this.role.includes(2) || this.role.includes(5))),
            tieneEditar: this.role.includes(7) && user==evaluacion.responsable.correoElectronico
          };

          this.dataSource.push(evaluacionData);
        });

        this.dataSource.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
        this._fuseProgressBarService.hide();

      });
    }


    navegateTo(url, id): void  {
        this.router.navigate([url, id]).then( (e) => {
          if (e) {
            console.log("Navigation is successful!");
          } else {
            console.log("Navigation has failed!");
          }
        });
    }

    print():void{
      var objSeleccionados = this.selection.selected;

      if(objSeleccionados.length==0){
        this.openSnackBar("Es necesario seleccionar al menos una fila.","Cerrar");
      }else{
        const dialogRef = this.dialog.open(DialogBoxPrintComponentAnalisisDeBrechas, {
          width: '100%',
          data: {action:"Print", obj:this.selection.selected},
          autoFocus: false,
          disableClose: true
        });
      }

    }

    updateCheckedList(element)
    {
      console.log(element);
    }

    cleanIds(data):any{

      data.id = null;

      return data;
    }

  isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.length;
      return numSelected === numRows;
    }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: AnalisisDeBrechas): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    //return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row`;
  }

  openDialog(action, obj): void {
    obj.action = action;
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      width: '100%',
      data: obj,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.event === 'Delete') {
        this.deleteRowData(result.data);
      }
    });
  }

  deleteRowData(row_obj): void {
    this.analisisDeBrechaservice.delete(row_obj.id).pipe(first()).subscribe(
      data => {
        console.log(data);
        this.dataSource = this.dataSource.filter((value, key) => {
          return value.id !== row_obj.id;
        });
        this.openSnackBar("Se eliminó el análisis correctamente.","Cerrar");
      },
      error => {
        console.log(error);
        this.openSnackBar("No se pudo eliminar el análisis, ocurrió un error.","Cerrar");
      }
    );
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  viewStatistics():void{
    var objSeleccionados = this.selection.selected;

    if(objSeleccionados.length==0){
      this.openSnackBar("Es necesario seleccionar al menos una fila.","Cerrar");
    }else{

      if(!this.coincidenLostipos()){
        this.openSnackBar("No se puede seleccionar tablas de evaluaciones diferentes para el reporte.","Cerrar");
      }else{
        const dialogRef = this.dialog.open(DialogAnalisisComparatorBoxAnalyticsComponentAnalisisDeBrechas, {
          panelClass: 'my-full-screen-dialog',
          width: '95%',
          maxWidth: '95%',
          height: '95%',
          maxHeight: '95%',
          data: {action:"Print", 
                sentenciasList: objSeleccionados
                },
          autoFocus: false,
          disableClose: true
        });
      }
    }
    
  }


  OnePageChange(event: PageEvent) {
    this.basicSlice = event.pageSize;
    this.getElements(event.pageIndex);
  }

  coincidenLostipos():boolean{

    var resultado:boolean = true;
    var primeraEval = this.selection.selected[0];

    for(var i=0; i < this.selection.selected.length ; i++){
      if(this.selection.selected[i].tablaDeAnalisisDeBrechas.nombre != primeraEval.tablaDeAnalisisDeBrechas.nombre)
        resultado = false;
    }
    
    return resultado;
  }

}
